module.exports = __webpack_public_path__ + "static/media/flying4.91923eef.gif";